import { useMemo } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

export const FIELDS = {
  NAME: 'name',
  AMOUNT: 'amount',
  FEE_AMOUNT: 'feeAmount',
  ADMIN_WITHDRAWAL_FEE_AMOUNT: 'adminWithdrawalFeeAmount',
  FAST_WITHDRAWAL_FEE_AMOUNT: 'fastWithdrawalFeeAmount',
  ADMIN_NOTE: 'adminNote',
  BILL_ACCOUNT_ID: 'billAccountId',
  IS_OTHER_RECIPIENT: 'isOtherRecipient',
  RECIPIENT_FULL_NAME: 'recipientInfoFullName',
  RECIPIENT_ID: 'recipientInfoRecipientId',
  RECIPIENT_PHONE: 'recipientInfoRecipientPhone',
  RECIPIENT_EMAIL: 'recipientInfoRecipientEmail',
}

export const useValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.AMOUNT]: Yup.number().nullable().required(intl.formatMessage({ id: "amountRequiredError" })),
      [FIELDS.FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.FAST_WITHDRAWAL_FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.ADMIN_NOTE]: Yup.string().optional().nullable(),
      [FIELDS.IS_OTHER_RECIPIENT]: Yup.boolean().optional().nullable(),
      [FIELDS.RECIPIENT_FULL_NAME]: Yup.string().when(FIELDS.IS_OTHER_RECIPIENT, {
        is: true,
        then: (schema) => schema.required(intl.formatMessage({ id: "recipientFullNameRequiredError" })),
        otherwise: (schema) => schema.optional().nullable(),
      }),
      [FIELDS.RECIPIENT_ID]: Yup.string().when(FIELDS.IS_OTHER_RECIPIENT, {
        is: true,
        then: (schema) => schema.required(intl.formatMessage({ id: "recipientIdRequiredError" })),
        otherwise: (schema) => schema.optional().nullable(),
      }),
      [FIELDS.RECIPIENT_PHONE]: Yup.string()
        .matches(/^[0-9+\-() ]*$/, intl.formatMessage({ id: "phoneInvalidError" }))
        .min(9, intl.formatMessage({ id: "phoneMinLengthError" }))
        .max(15, intl.formatMessage({ id: "phoneMaxLengthError" }))
        .when(FIELDS.IS_OTHER_RECIPIENT, {
          is: true,
          then: (schema) => schema.required(intl.formatMessage({ id: "recipientPhoneRequiredError" })),
          otherwise: (schema) => schema.optional().nullable(),
        }),
      [FIELDS.RECIPIENT_EMAIL]: Yup.string().when(FIELDS.IS_OTHER_RECIPIENT, {
        is: true,
        then: (schema) => schema.email(intl.formatMessage({ id: "emailInvalidError" })).required(intl.formatMessage({ id: "recipientEmailRequiredError" })),
        otherwise: (schema) => Yup.string().optional().nullable(),
      }),
    })
  }, [intl])
};

export const useServiceValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.NAME]: Yup.string().required(intl.formatMessage({ id: "transactionNameRequiredError" })).min(3, intl.formatMessage({ id: "transactionNameMinError" })),
      [FIELDS.FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.ADMIN_WITHDRAWAL_FEE_AMOUNT]: Yup.number().min(0.01, intl.formatMessage({ id: "numberMinError" })).required(intl.formatMessage({ id: "adminFeeRequiredError" })),
      [FIELDS.FAST_WITHDRAWAL_FEE_AMOUNT]: Yup.number().min(0, intl.formatMessage({ id: "numberMinError" })).nullable(),
      [FIELDS.ADMIN_NOTE]: Yup.string().optional().nullable(),
    })
  }, [intl])
};